import { MDSDropdown } from '@marqvision/mds-v2';
import { useModelOptions } from '~/components/Filters/@hooks';
import { ResponsiveProps } from '~/components/Responsive/@types';

export const ModelsFilter = (props: ResponsiveProps) => {
  const models = useModelOptions();
  const { size = 'medium' } = props;

  return (
    <>
      {/*added logic to display model filter only when model is available from client*/}
      {models.shouldDisplayFilter && (
        <MDSDropdown
          label="Models"
          value={models.selected}
          list={models.list}
          isDisabled={models.disabled}
          isLoading={models.isFetching}
          onChange={(value) => models.select(value)}
          modules={[
            'search',
            {
              type: 'filter-button',
              size,
            },
          ]}
        />
      )}
    </>
  );
};
